export const academyCustomPagesKeys = {
  root: ['academyCustomPage'],
  academyCustomPages: (academyId: string) => [...academyCustomPagesKeys.root, academyId],
  academyCustomPage: (academyId: string, pageId: string) => [...academyCustomPagesKeys.root, academyId, pageId],
};
